/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Already_ExistsInputs */

const en_us2_session_already_exists = /** @type {(inputs: Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not start your session. Please try again.`)
};

const pt_br2_session_already_exists = /** @type {(inputs: Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível iniciar sua sessão. Tente de novo.`)
};

const es_419_session_already_exists = /** @type {(inputs: Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos iniciar tu sesión. Intenta de nuevo.`)
};

const pt_pt2_session_already_exists = /** @type {(inputs: Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível iniciar a tua sessão. Tenta outra vez.`)
};

const fr_fr2_session_already_exists = /** @type {(inputs: Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de démarrer ta séance. Réessaie.`)
};

const de_de2_session_already_exists = /** @type {(inputs: Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Einheit konnte nicht gestartet werden. Versuch es bitte noch mal.`)
};

const it_it2_session_already_exists = /** @type {(inputs: Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile avviare la sessione. Riprova.`)
};

/**
* | output |
* | --- |
* | "We could not start your session. Please try again." |
*
* @param {Session_Already_ExistsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const session_already_exists = /** @type {((inputs?: Session_Already_ExistsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Already_ExistsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_session_already_exists(inputs)
	if (locale === "es-419") return es_419_session_already_exists(inputs)
	if (locale === "pt-PT") return pt_pt2_session_already_exists(inputs)
	if (locale === "fr-FR") return fr_fr2_session_already_exists(inputs)
	if (locale === "de-DE") return de_de2_session_already_exists(inputs)
	if (locale === "it-IT") return it_it2_session_already_exists(inputs)
	return en_us2_session_already_exists(inputs)
});
export { session_already_exists as "session.already_exists" }